import { styled } from '../theme';
import Text from './Text';

const H3 = styled(Text.withComponent('h3'))(({ theme }) => ({
    fontWeight: theme.typography.fontWeight.medium,
    fontSize: '2.4rem',
    margin: 0,
    padding: 0,
}));

export default H3;
